export const Z_ENV_BAR_ATTRIBUTE = 'data-z-env-bar';
export const Z_ENV_BAR_SELECTOR = `[${Z_ENV_BAR_ATTRIBUTE}]`;
export const Z_ENV_BAR_ATTRS = {
  [Z_ENV_BAR_ATTRIBUTE]: '',
} as const;
